import React, { useEffect } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import DetailPrivacyPolicy from '../../components/DetailPrivacyPolicy/DetailPrivacyPolicy';

function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ overflow: 'hidden' }}>
      <Navbar />
      <DetailPrivacyPolicy />
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
